import React from "react";
import PropTypes from "prop-types";

export default function ClientUpload(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill={props.fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ballot_24px">
        <path
          id="icon/content/ballot_24px"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 21.5415H19C20.1 21.5415 21 20.6415 21 19.5415V5.5415C21 4.4415 20.1 3.5415 19 3.5415H5C3.9 3.5415 3 4.4415 3 5.5415V19.5415C3 20.6415 3.9 21.5415 5 21.5415ZM14 10.0415H17C17.55 10.0415 18 9.5915 18 9.0415C18 8.4915 17.55 8.0415 17 8.0415H14C13.45 8.0415 13 8.4915 13 9.0415C13 9.5915 13.45 10.0415 14 10.0415ZM14 17.0415H17C17.55 17.0415 18 16.5915 18 16.0415C18 15.4915 17.55 15.0415 17 15.0415H14C13.45 15.0415 13 15.4915 13 16.0415C13 16.5915 13.45 17.0415 14 17.0415ZM7 11.5415H10C10.55 11.5415 11 11.0915 11 10.5415V7.5415C11 6.9915 10.55 6.5415 10 6.5415H7C6.45 6.5415 6 6.9915 6 7.5415V10.5415C6 11.0915 6.45 11.5415 7 11.5415ZM10 7.54151H7V10.5415H10V7.54151ZM7 18.5415H10C10.55 18.5415 11 18.0915 11 17.5415V14.5415C11 13.9915 10.55 13.5415 10 13.5415H7C6.45 13.5415 6 13.9915 6 14.5415V17.5415C6 18.0915 6.45 18.5415 7 18.5415ZM10 14.5415H7V17.5415H10V14.5415Z"
        />
      </g>
    </svg>
  );
}

ClientUpload.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
ClientUpload.defaultProps = {
  className: "",
  fill: "#93ABCA",
  width: 15,
  height: 17
};
